import { getFormattedDate } from '../../utils'

export const formatHistoryValue = (value: unknown) => {
  if (value === null || value === undefined || value === '') return '—'
  try {
    const date = new Date(value as string)
    if (date.toString() === 'Invalid Date') throw new Error('Invalid date')
    return getFormattedDate(date)
  } catch {
    if (typeof value === 'string') return value
    if (typeof value === 'number' || typeof value === 'boolean') return String(value)
    return JSON.stringify(value)
  }
}

export const snakeToText = (str: string, titleCase = false): string =>
  str
    .replace(/_+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(titleCase ? /\b\w/g : /^\w/, c => c.toUpperCase())
